import { AbstractEntityTabLoader } from '../../utils/component/abstract-entity-tab-loader/abstract-entity-tab.loader';
import { ExplanationEntity } from '../explanation-entity';

export class ExplanationTabLoader
  extends AbstractEntityTabLoader<ExplanationEntity> {
  protected pageSize = 20;
  protected sort = 'name';
  protected searchFilterKey = 'filter[nameLike]';
}
